<template>
  <div class="admin-submissions">
    <!-- 搜索和筛选区域 -->
    <div class="search-section">
      <el-card>
        <div class="search-form">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input v-model="searchForm.keyword" :placeholder="$t('admin.submissions.search.placeholder')" clearable
                @keyup.enter="handleSearch">
                <template #prefix>
                  <el-icon>
                    <Search />
                  </el-icon>
                </template>
              </el-input>
            </el-col>
            <!-- <el-col :span="4">
              <el-select v-model="searchForm.status" :placeholder="$t('admin.submissions.search.status')" clearable>
                <el-option :label="$t('admin.submissions.status.pending')" value="pending" />
                <el-option :label="$t('admin.submissions.status.approved')" value="approved" />
                <el-option :label="$t('admin.submissions.status.rejected')" value="rejected" />
              </el-select>
            </el-col> -->
            <el-col :span="6">
              <el-date-picker v-model="searchForm.dateRange" type="daterange" :range-separator="$t('common.to')"
                :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" format="YYYY-MM-DD"
                value-format="YYYY-MM-DD" clearable />
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="handleSearch">
                <el-icon>
                  <Search />
                </el-icon>
                {{ $t('admin.submissions.search.button') }}
              </el-button>
              <el-button @click="handleReset">
                <el-icon>
                  <Refresh />
                </el-icon>
                {{ $t('common.refresh') }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>

    <!-- 操作按钮区域 -->
    <div class="action-section">
      <el-card>
        <div class="action-buttons">
          <el-button type="success" @click="handleRefresh">
            <el-icon>
              <Refresh />
            </el-icon>
            {{ $t('admin.submissions.actions.refresh') }}
          </el-button>
          <!-- <el-button type="primary" @click="handleExport">
            <el-icon>
              <Download />
            </el-icon>
            {{ $t('admin.submissions.actions.export') }}
          </el-button> -->
        </div>
      </el-card>
    </div>

    <!-- 数据表格 -->
    <div class="table-section">
      <el-card>
        <el-table v-loading="loading" :data="tableData" stripe border style="width: 100%"
          :empty-text="$t('admin.submissions.table.noData')">
          <el-table-column prop="id" :label="$t('admin.submissions.table.id')" width="80" align="center" />
          <el-table-column prop="research_title" :label="$t('admin.submissions.table.title')" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="authorName" :label="$t('admin.submissions.table.author')" width="150">
            <template #default="{ row }">
              {{ row.authors[0].name }}
            </template>
          </el-table-column>
          <el-table-column prop="authorEmail" :label="$t('admin.submissions.table.email')" width="200"
            show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.authors[0].email }}
            </template>
          </el-table-column>
          <el-table-column prop="authorAffiliation" :label="$t('admin.submissions.table.affiliation')" width="200"
            show-overflow-tooltip>
            <template #default="{ row }">
              {{ row.authors[0].affiliation }}
            </template>
          </el-table-column>
          <el-table-column prop="abstractFile" :label="$t('admin.submissions.table.abstractFile')" width="120"
            align="center">
            <template #default="{ row }">
              <el-button v-if="row.abstract_files.length > 0" type="primary" size="small" @click="handleDownloadAbstract(row)">
                <el-icon>
                  <Download />
                </el-icon>
                {{ $t('admin.submissions.table.download') }}
              </el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="posterFile" :label="$t('admin.submissions.table.posterFile')" width="120"
            align="center">
            <template #default="{ row }">
              <el-button v-if="row.poster_files.length > 0" type="success" size="small" @click="handleDownloadPoster(row)">
                <el-icon>
                  <Download />
                </el-icon>
                {{ $t('admin.submissions.table.download') }}
              </el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" :label="$t('admin.submissions.table.submissionTime')" width="180"
            align="center">
            <template #default="{ row }">
              {{ formatDate(row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('admin.submissions.table.actions')" align="center" fixed="right">
            <template #default="{ row }">
              <el-button type="primary" size="small" @click="handleView(row)">
                {{ $t('admin.submissions.table.view') }}
              </el-button>
              <!-- <el-button type="warning" size="small" @click="handleEdit(row)">
                {{ $t('admin.submissions.table.edit') }}
              </el-button> -->
              <!-- <el-button type="danger" size="small" @click="handleDelete(row)">
                {{ $t('admin.submissions.table.delete') }}
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-section">
          <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange" @current-change="handleCurrentChange">
            <template #total>
              {{ $t('admin.submissions.pagination.total', { total: pagination.total }) }}
            </template>
          </el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog v-model="detailVisible" :title="$t('admin.submissions.modal.title')" width="800px"
      :close-on-click-modal="false">
      <div v-if="currentRecord" class="detail-content">
        <el-descriptions :column="2" border>
          <el-descriptions-item :label="$t('admin.submissions.table.id')">
            {{ currentRecord.id }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('admin.submissions.table.title')" :span="2">
            {{ currentRecord.research_title }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('admin.submissions.table.author')">
            {{ currentRecord.authors[0].name }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('admin.submissions.table.email')">
            {{ currentRecord.authors[0].email }}
          </el-descriptions-item>
          <el-descriptions-item :label="$t('admin.submissions.table.affiliation')" :span="2">
            {{ currentRecord.authors[0].affiliation }}
          </el-descriptions-item>
          <!-- <el-descriptions-item :label="$t('admin.submissions.table.abstract')" :span="2">
            <div class="abstract-content">
              {{ currentRecord.abstract_files }}
            </div>
          </el-descriptions-item> -->
          <el-descriptions-item :label="$t('admin.submissions.table.submissionTime')" :span="2">
            {{ formatDate(currentRecord.created_at) }}
          </el-descriptions-item>
        </el-descriptions>

        <!-- 文件下载区域 -->
        <div class="file-section">
          <h4>{{ $t('admin.submissions.modal.files') }}</h4>
          <div class="file-buttons">
            <el-button v-if="currentRecord.abstract_files && currentRecord.abstract_files.length > 0" type="primary"
              @click="handleDownloadAbstract(currentRecord)">
              <el-icon>
                <Download />
              </el-icon>
              {{ $t('admin.submissions.table.downloadAbstract') }}
            </el-button>
            <el-button v-if="currentRecord.poster_files && currentRecord.poster_files.length > 0" type="success"
              @click="handleDownloadPoster(currentRecord)">
              <el-icon>
                <Download />
              </el-icon>
              {{ $t('admin.submissions.table.downloadPoster') }}
            </el-button>
          </div>
        </div>
      </div>
      <template #footer>
        <el-button @click="detailVisible = false">
          {{ $t('admin.submissions.modal.close') }}
        </el-button>
      </template>
    </el-dialog>

    <!-- 编辑状态弹窗 -->
    <!-- <el-dialog v-model="editVisible" :title="$t('admin.submissions.edit.title')" width="500px"
      :close-on-click-modal="false">
      <el-form v-if="currentRecord" ref="editFormRef" :model="editForm" label-width="120px">
        <el-form-item :label="$t('admin.submissions.table.status')">
          <el-select v-model="editForm.status" style="width: 100%">
            <el-option :label="$t('admin.submissions.status.pending')" value="pending" />
            <el-option :label="$t('admin.submissions.status.approved')" value="approved" />
            <el-option :label="$t('admin.submissions.status.rejected')" value="rejected" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('admin.submissions.edit.remarks')">
          <el-input v-model="editForm.remarks" type="textarea" :rows="4"
            :placeholder="$t('admin.submissions.edit.remarksPlaceholder')" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editVisible = false">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" @click="handleSaveEdit">
          {{ $t('common.save') }}
        </el-button>
      </template>
    </el-dialog> -->
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, Refresh, Download } from '@element-plus/icons-vue'
import { getSubmissions } from '@/api/submission'
import { useI18n } from 'vue-i18n'

export default {
  name: 'AdminSubmissions',
  components: {
    Search,
    Refresh,
    Download
  },
  setup() {
    const { t } = useI18n()

    // 响应式数据
    const loading = ref(false)
    const tableData = ref([])
    const detailVisible = ref(false)
    const editVisible = ref(false)
    const currentRecord = ref(null)

    // 搜索表单
    const searchForm = reactive({
      keyword: '',
      status: '',
      dateRange: null
    })

    // 编辑表单
    const editForm = reactive({
      status: '',
      remarks: ''
    })

    // 分页数据
    const pagination = reactive({
      page: 1,
      pageSize: 20,
      total: 0
    })

    // 获取数据
    const fetchData = async () => {
      loading.value = true
      try {
        const params = {
          page: pagination.page,
          per_page: pagination.pageSize,
          keyword: searchForm.keyword || undefined,
          status: searchForm.status || undefined
        }

        // 处理日期范围
        if (searchForm.dateRange && searchForm.dateRange.length === 2) {
          params.start_date = searchForm.dateRange[0]
          params.end_date = searchForm.dateRange[1]
        }

        const response = await getSubmissions(params)
        if (response.success) {
          tableData.value = response.data
          pagination.total = response.pagination.total
        } else {
          ElMessage.error(response.message || t('common.error'))
        }
      } catch (error) {
        console.error('获取提交列表失败:', error)
        ElMessage.error(t('common.error'))
      } finally {
        loading.value = false
      }
    }

    // 搜索
    const handleSearch = () => {
      pagination.page = 1
      fetchData()
    }

    // 重置
    const handleReset = () => {
      searchForm.keyword = ''
      searchForm.status = ''
      searchForm.dateRange = null
      pagination.page = 1
      fetchData()
    }

    // 刷新
    const handleRefresh = () => {
      fetchData()
    }

    // 导出
    const handleExport = () => {
      ElMessage.info(t('common.developing'))
    }

    // 查看详情
    const handleView = (row) => {
      currentRecord.value = row
      detailVisible.value = true
    }

    // 编辑
    const handleEdit = (row) => {
      currentRecord.value = row
      editForm.status = row.status
      editForm.remarks = row.remarks || ''
      editVisible.value = true
    }

    // 保存编辑
    const handleSaveEdit = async () => {
      try {
        // TODO: 实现更新API
        ElMessage.success(t('common.saveSuccess'))
        editVisible.value = false
        fetchData()
      } catch (error) {
        console.error('保存失败:', error)
        ElMessage.error(t('common.error'))
      }
    }

    // 删除
    const handleDelete = async (row) => {
      try {
        await ElMessageBox.confirm(
          t('common.deleteConfirm'),
          t('common.warning'),
          {
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel'),
            type: 'warning'
          }
        )

        // TODO: 实现删除API
        ElMessage.success(t('common.deleteSuccess'))
        fetchData()
      } catch {
        // 用户取消删除
      }
    }

    // 下载摘要文件
    const handleDownloadAbstract = async (row) => {
      if (!row.abstract_files || row.abstract_files.length === 0) {
        ElMessage.warning(t('admin.submissions.download.noFile'))
        return
      }

      try {
        // 创建下载链接
        const link = document.createElement('a')
        link.href = `${process.env.VUE_APP_API_URL}/submissions/${row.id}/download/abstract`
        link.download = `abstract_${row.id}.zip`
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        ElMessage.success(t('admin.submissions.download.success'))
      } catch (error) {
        console.error('下载摘要文件失败:', error)
        ElMessage.error(t('admin.submissions.download.noFile'))
      }
    }

    // 下载海报文件
    const handleDownloadPoster = async (row) => {
      if (!row.poster_files || row.poster_files.length === 0) {
        ElMessage.warning(t('admin.submissions.download.noFile'))
        return
      }

      try {
        // 创建下载链接
        const link = document.createElement('a')
        link.href = `${process.env.VUE_APP_API_URL}/submissions/${row.id}/download/poster`
        link.download = `poster_${row.id}.zip`
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        ElMessage.success(t('admin.submissions.download.success'))
      } catch (error) {
        console.error('下载海报文件失败:', error)
        ElMessage.error(t('admin.submissions.download.noFile'))
      }
    }

    // 分页大小改变
    const handleSizeChange = (size) => {
      pagination.pageSize = size
      pagination.page = 1
      fetchData()
    }

    // 当前页改变
    const handleCurrentChange = (page) => {
      pagination.page = page
      fetchData()
    }

    // 格式化日期
    const formatDate = (dateString) => {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }

    // 获取状态文本
    const getStatusText = (status) => {
      const map = {
        pending: t('admin.submissions.status.pending'),
        approved: t('admin.submissions.status.approved'),
        rejected: t('admin.submissions.status.rejected')
      }
      return map[status] || status
    }

    // 获取状态颜色
    const getStatusColor = (status) => {
      const map = {
        pending: 'warning',
        approved: 'success',
        rejected: 'danger'
      }
      return map[status] || 'info'
    }

    // 组件挂载时获取数据
    onMounted(() => {
      fetchData()
    })

    return {
      loading,
      tableData,
      searchForm,
      editForm,
      pagination,
      detailVisible,
      editVisible,
      currentRecord,
      fetchData,
      handleSearch,
      handleReset,
      handleRefresh,
      handleExport,
      handleView,
      handleEdit,
      handleSaveEdit,
      handleDelete,
      handleDownloadAbstract,
      handleDownloadPoster,
      handleSizeChange,
      handleCurrentChange,
      formatDate,
      getStatusText,
      getStatusColor
    }
  }
}
</script>

<style scoped>
.admin-submissions {
  padding: 0;
}

.search-section,
.action-section,
.table-section {
  margin-bottom: 20px;
}

.search-form {
  padding: 10px 0;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.pagination-section {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.detail-content {
  padding: 20px 0;
}

.abstract-content {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
}

.file-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.file-section h4 {
  margin-bottom: 10px;
  color: #303133;
}

.file-buttons {
  display: flex;
  gap: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .search-form .el-col {
    margin-bottom: 10px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .file-buttons {
    flex-direction: column;
  }

  .el-table {
    font-size: 12px;
  }
}
</style>